import { render, staticRenderFns } from "./SignUpCompletePage.vue?vue&type=template&id=ba40d2fc"
import script from "./SignUpCompletePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpCompletePage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports